import moment from "moment"

export default {
	state: {
		clientServices: []
	},

	actions: {
		getClientServices(actionContext, parameters) {
			return new Promise((resolve, reject) => {
				try {
					actionContext.commit("Loading/show", null, { root: true })

					var columns = "distinct"
						+ " cf.clientid"
						+ ", concat(c.firstname, ' ', c.lastname) as client"
						+ ", st.id as serviceid"
						+ ", st.name as service"
						+ ", st.maxtraveltime"
						+ ", st.maxtravelmileage"
						+ ", st.maxtransportmileage"
						+ ", st.code as servicetypecode"

					var tableName = "" +
						"@db.clientfunding cf"
						+ " inner join @db.clientfundingcode cfc on cf.id = cfc.clientfundingid and cfc.inactive = 0 and cf.inactive = 0"
						+ " inner join @db.servicetype st on cfc.servicetypeid = st.id and st.careworkermanagement = 1"
						+ " inner join @db.client c on cf.clientid = c.id and c.inactive = 0"

					var filter = "" +
						`c.id = ${parameters.customerId}`
						+ ` and date('${parameters.date}') between date(cf.startdate) and date(cf.enddate)`

					actionContext.rootGetters["MopaneApi/getInstance"].get(`Service/GetTableData?columns=${columns}&tableName=${tableName}&filter=${filter}`)
						.then(response => {
							var records = actionContext.rootGetters["MopaneApi/getObjectArrayFromTable"](response.data)

							actionContext.commit("setClientServices", records)
							actionContext.commit("Loading/hide", null, { root: true })

							resolve()
						})
						.catch(response => {
							actionContext.dispatch("MopaneApi/processErrorResponse", response, { root: true })
							actionContext.commit("Loading/hide", null, { root: true })

							reject(response)
						})
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		}
	},

	getters: {
		clientServices(state) {
			return (clientid, date) => {
				return state.clientServices.filter(x => x.clientid == clientid && moment(date).isBetween(moment(x.startdate, "DD/MM/YYYY hh:mm:ss A"), moment(x.enddate, "DD/MM/YYYY hh:mm:ss A")))
			}
		}
	},

	mutations: {
		setClientServices(state, clientServices) {
			state.clientServices = clientServices
		}
	},

	namespaced: true
}